import { useTranslation } from 'react-i18next'

import { NUMBER_SIZE } from '../../../../constants/size'
import Button from '../../../Button'
import { Counter, THEME_VARIANT } from '../../../Counter'
import { ICON_CHEVRON_DIRECTION, IconChevron } from '../../../Icon'

import * as styles from './SupportLauncherButton.module.css'

import FAQIcon from '../../../../icons/faq.svg'

function SupportLauncherButton({ isPressed, ref, unreadCount }) {
  const { t } = useTranslation()

  return (
    <div className={styles.wrapper} ref={ref}>
      <Button.White
        beforeIconProps={{
          Icon: isPressed ? IconChevron : FAQIcon,
          iconProps: {
            direction: isPressed ? ICON_CHEVRON_DIRECTION.UP : null,
          },
        }}
        className={styles.supportButton}
        height={NUMBER_SIZE.size48}
      >
        {t('Common.SupportButtonKey')}
      </Button.White>
      <Counter
        className={styles.counter}
        count={unreadCount}
        variant={THEME_VARIANT}
      />
    </div>
  )
}

export default SupportLauncherButton
